import React from 'react';
import PropTypes from 'prop-types';
import { BUTTON, SIZES } from 'constants/components';
import CircleLoader from 'components/common/CircleLoader';
import { ButtonElement, ButtonLinkElement, TextElement, IconElement } from './Button.styled';

export const Button = props => {
  let {
    disabled,
    onClick,
    children,
    type,
    layout,
    suffixIcon,
    textTransform,
    tabIndex,
    link,
    onBlur,
    onFocus,
    isLoading,
    loaderIconSize,
    target,
    ...other
  } = props;

  let Element = link ? ButtonLinkElement : ButtonElement;

  return (
    <Element
      onClick={onClick}
      disabled={disabled}
      type={type}
      layout={layout}
      suffixIcon={suffixIcon}
      textTransform={textTransform}
      tabIndex={tabIndex}
      href={link}
      onBlur={onBlur}
      onFocus={onFocus}
      target={target || '_blank'}
      isLoading={isLoading}
      {...other}
    >
      <TextElement ellipsis layout={layout}>
        {children}
      </TextElement>
      {suffixIcon && <IconElement name={suffixIcon} size={12} />}
      {isLoading && <CircleLoader iconSize={loaderIconSize} />}
    </Element>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  suffixIcon: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  layout: PropTypes.oneOf([BUTTON.LAYOUT.PRIMARY, BUTTON.LAYOUT.SECONDARY]),
  size: PropTypes.oneOf([SIZES.SMALL, SIZES.MEDIUM]),
  textTransform: PropTypes.string,
  tabIndex: PropTypes.number,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  link: PropTypes.string,
  isLoading: PropTypes.bool,
  loaderIconSize: PropTypes.number,
  target: PropTypes.string
};

Button.defaultProps = {
  layout: BUTTON.LAYOUT.PRIMARY,
  size: SIZES.MEDIUM,
  isLoading: false,
  loaderIconSize: 24
};

export default Button;
